<script lang="ts">
  import { onMount } from "svelte";

  import type { GAQFacet, PricingSearchResult } from "../../.../../../../typings/GetAQuote";
  import { hasFacetsOpen } from "../../stores/GAQStore";
  import { getGroupedFacets } from "../FindServiceForm";
  import FacetFilterIcon from "../../Icons/FacetFilterIcon.svelte";

  export let results: PricingSearchResult[] = null;
  export let selectedFacetValueIds = [];
  export let hasFacets: boolean = false;

  let facetGroups: GAQFacet[] = null;
  $: if (facetGroups) {
    selectedFacetValueIds = facetGroups.reduce((results, curr) => {
      let checkedFacetValues = curr.facetValues.filter((fv) => fv.checked);
      if (checkedFacetValues) {
        results.push(...checkedFacetValues.map((fv) => fv.id));
      }
      return results;
    }, []);
  }

  function handleIsFacetValueDisabled(facetTitle: string) {
    const checkedFacetGroup = facetGroups.find((f) => f.facetValues.some((fv) => fv.checked));
    if (checkedFacetGroup) {
      if (checkedFacetGroup.facetTitle === facetTitle) {
        return false;
      } else {
        return true;
      }
    }
    return false;
  }


  function dispatchSelectServiceFilterEvent(event: ChangeEvent) {
    const checkbox = event.target as HTMLInputElement;

    if (checkbox.checked) {
      const filterName = checkbox.closest(".facet").querySelector(".facet__title").textContent.trim();
      const filterValue = checkbox.parentNode.textContent.trim();

      const args = {
        event: "serviceFilter",
        filterName,
        filterValue,
      };

      window.dataLayer.push(args);
    }
  }


  onMount(() => {
    facetGroups = getGroupedFacets(results);
    hasFacets = facetGroups != null && facetGroups.length > 0;
  });
</script>

{#if facetGroups && facetGroups.length}
  <div class="facet__container" class:open={$hasFacetsOpen}>
    <div class="facet__heading">
      <div class="facet__heading-left">
        <FacetFilterIcon />
        <p>Filter Services</p>
      </div>
      <button class="btn-facets-close btn-reset" on:click={(_) => hasFacetsOpen.set(false)}>Close</button>
    </div>

    {#each facetGroups as facet (facet.facetTitle)}
      <div class="facet">
        <h4 class="facet__title">{facet.facetTitle}</h4>
        <ul class="facet__values list-unstyled">
          {#each facet.facetValues as facetValue (facetValue.id)}
            <li class="facet__value">
              <div class="form-check" class:disabled={handleIsFacetValueDisabled(facet.facetTitle)}>
                <label class="form-check-label">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    value={facetValue.id}
                    id="flexCheckChecked"
                    data-gtm-element-type="service-filter"
                    bind:checked={facetValue.checked}
                    disabled={handleIsFacetValueDisabled(facet.facetTitle)}
                    on:change={dispatchSelectServiceFilterEvent}
                  />
                  {facetValue.label}
                </label>
              </div>
            </li>
          {/each}
        </ul>
      </div>
    {/each}

    <div class="facet__apply">
      <button class="btn-facets-apply btn btn-primary" on:click={(_) => hasFacetsOpen.set(false)}>Apply</button>
    </div>
  </div>
{/if}
